import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { MenuGroupCreateService } from '../../services';

export const fetchMenuGroupCreate = createAsyncThunk(
    'menuGroupCreate/fetchMenuGroupCreate',
    async ({ file, title, description, content }) => {
        const response = await MenuGroupCreateService(file, title, description, content)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const menuGroupCreateSlice = createSlice({
    name: 'menuGroupCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGroupCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGroupCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGroupCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGroupCreateSlice.reducer;
